export type LoaderSize = 'xs' | 'sm' | 'md' | 'lg';

/** Nombre de barres du motif — doit rester aligné sur `$moon-loader-bars` (`_loader.scss`). */
export const LOADER_BAR_COUNT = 8;

/** Indices des barres, pour les `@for` des gabarits Angular. */
export const LOADER_BARS: readonly number[] = Array.from({ length: LOADER_BAR_COUNT }, (_, i) => i);

/**
 * Balisage du motif sous forme de chaîne, pour les contextes qui ne peuvent pas instancier de
 * composant (overlay de chargement d'ag-Grid, monté en innerHTML).
 *
 * Statique : `size` est contraint par le type, aucune donnée n'y est interpolée.
 */
export function loaderMarkup(size: LoaderSize): string {
  const bars = '<span class="moon-loader__bar"></span>'.repeat(LOADER_BAR_COUNT);
  return `<span class="moon-loader moon-loader--${size}" aria-hidden="true">${bars}</span>`;
}
